import { render, staticRenderFns } from "./ImagesManagementApprove.vue?vue&type=template&id=08302c8a&scoped=true&"
import script from "./ImagesManagementApprove.vue?vue&type=script&lang=js&"
export * from "./ImagesManagementApprove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08302c8a",
  null
  
)

export default component.exports